"use client"

import clsx from "clsx"

import type { Nullish } from "~/@types/generics"
import type { TVariant } from "~/lib/shopify/serializers/serialize-variants"
import type { UnlikelyCartLineItemInput } from "~/lib/shopify/types"
import type { TProductHeaderWithEmbroidery } from "~/components/ui/Product/ProductHeader/_data/utils/is-product-header-with-embroidery"
import { PanelEmbroidery } from "~/components/ui/Product/ProductHeader/PanelEmbroidery"
import RoundedCta, { type RoundedCtaProps } from "~/components/ui/RoundedCta"
import { useTranslate } from "~/providers/I18nProvider/hooks/useTranslate"
import { usePanel } from "~/managers/PanelManager"

import { sprinkles, type Sprinkles } from "~/styles/sprinkles.css"

type PanelEmbroideryTriggerProps = {
  sprinklesCss?: Sprinkles
  currentVariant: Nullish<TVariant>
  productHeader: TProductHeaderWithEmbroidery
  productLineItem: UnlikelyCartLineItemInput
} & Omit<RoundedCtaProps, "onClick">

export function PanelEmbroideryTrigger({
  sprinklesCss,
  className,
  currentVariant,
  productHeader,
  productLineItem,
  ...props
}: PanelEmbroideryTriggerProps) {
  const { add } = usePanel()
  const t = useTranslate()

  return (
    <RoundedCta
      type="secondary"
      theme="blue-deep"
      width="full"
      onClick={() =>
        add(
          <PanelEmbroidery
            currentVariant={currentVariant}
            productHeader={productHeader}
            productLineItem={productLineItem}
          />
        )
      }
      className={clsx(className, sprinkles({ ...(sprinklesCss ?? {}) }))}
      {...props}
    >
      {t("embroidery_trigger")}
    </RoundedCta>
  )
}
